export default {
    resultType: {
        text: 1,
        tile: 2,
        downloads: 3
    },
    resultKind: {
        all: "all",
        boards: "boards",
        decor: "decor",
        structure: "structure",
        reference: "reference",
        page: "page",
        downloads: "downloads"
    },
    resultsPerPage: 12
}
